import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import googlePlay from "../assets/play.svg";
import appStore from "../assets/apple.svg";

const contactItems = [
  {
    label: "address",
    icon: FaMapMarkerAlt,
    content: <span>Namuswa plaza, Kampala, Uganda</span>,
  },
  {
    label: "phone",
    icon: FaPhoneAlt,
    content: <a href="tel:+256773344472">+256 773 344 472</a>,
  },
  {
    label: "email",
    icon: FaEnvelope,
    content: <a href="mailto:customercare@carmie.biz">customercare@carmie.biz</a>,
  },
];

export default function Footer() {
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/");
    setTimeout(() => {
      const target = document.getElementById(id);
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - 104;
      window.scrollTo({ top, behavior: "smooth" });
    }, 120);
  };

  return (
    <footer className="bg-[#101712] py-12 text-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div>
            <h3 className="text-xl font-black">Carmie support</h3>
            <p className="mt-2 max-w-xs text-sm leading-6 text-white/62">
              Service questions, garage onboarding, and driver support for the
              launch network.
            </p>
            <ul className="mt-4 space-y-3 text-sm text-white/76">
              {contactItems.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.label} className="flex gap-3">
                    <Icon className="mt-1 text-[#8FE85E]" aria-hidden="true" />
                    <span className="footer-link">{item.content}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-black">Network</h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/mechanicApp" className="footer-link">
                  Become a Carmie mechanic
                </Link>
              </li>
              <li>
                <button type="button" onClick={() => goToSection("join")} className="footer-link">
                  Partner with Carmie
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-black">Company</h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <button type="button" onClick={() => goToSection("about")} className="footer-link">
                  About Carmie
                </button>
              </li>
              <li>
                <button type="button" onClick={() => goToSection("faq")} className="footer-link">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-black">Policies</h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/terms" className="footer-link">
                  Terms of use
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="footer-link">
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link to="/deletion-terms" className="footer-link">
                  Account deletion
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-black">App access</h3>
            <p className="mt-2 text-sm leading-6 text-white/62">
              Store launch links will be updated when Carmie opens public
              downloads.
            </p>
            <div className="mt-4 flex flex-col gap-3">
              <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
                <img src={googlePlay} alt="Google Play Store" className="w-40" />
              </a>
              <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
                <img src={appStore} alt="Apple App Store" className="w-40" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-center text-sm text-white/55">
          <p>© {new Date().getFullYear()} Carmie. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
